import React, { useEffect } from "react";
import { Row } from "react-bootstrap";
import "./MyridePage.css";
import { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import NodatafoundPage from "../../../nodatafound/components/NodatafoundPage";
import no_orders from "../../../../assets/order_empty_icon.svg";
import { useTranslation } from "react-i18next";
import default_car from "../../../../assets/default_car.svg";
import { API_SEND_BOOKING_STATUS_NOTIFICATION, BOOKING_STATUS, MY_RIDES } from "../../../constants/apiurl";
import { postRequestcall } from "../../../comman/util/postRequest";
import { getRequestcall } from "../../../comman/util/getRequest";
import PaginationPage from "../../../comman/components/PaginationPage";
import { toast } from "react-toastify";
import { clearStoredetail } from "../../../dashboard/redux/actions";
import { fetchLogindata } from "../../../login/redux/actions";
import { useNavigate } from "react-router-dom";
import { receivedRidecount } from "../../../user/dashboard/redux/actions";
import moment from "moment";
import DeletepopupPage from "../../../modal/components/DeletepopupPage";
import { setStoreModalPopupShow } from "../../../home/redux/actions";

function MyridePage(props) {
  // moment.locale(props?.language?.toLowerCase())
  const dispatch = useDispatch();
  const modal_common = useSelector((state)=>state?.home?.modal_common)

  let url = window.location.pathname.split("/");
  const [ridedetail, setRidedetail] = useState({});
  const [nodata, setNodata] = useState(false);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const modal_common_default = {
    title:"",
    sub_title:"",
    name:"",
    type:"",
    show:false,
    itemDelete:()=>{}
  }
  // eslint-disable-next-line
  useEffect(() => {
    myRidelisting(1);
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
   if(modal_common === undefined){
    callSetState();
   }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const callSetState = () =>{
    dispatch(setStoreModalPopupShow(modal_common_default));
  }

  const myRidelisting = async (page) => {
    let getUrl;
    console.log("url 3",url[3])
    if (typeof url[3] === "undefined" || url[3] === "total") {
      if (props?.dashboard === true) {
        getUrl = MY_RIDES + `?type=${url[1]}&page=${page}&read_status_update=${"no"}&lang=${props?.language?.toLowerCase()}`;
      } else {
         if(url[1] === "vendor") {
          console.log("hello",url[3]);
          getUrl = MY_RIDES + `?type=${url[1]}&page=${page}&read_status_update=${"yes"}&lang=${props?.language?.toLowerCase()}`;
         }else{
          getUrl = MY_RIDES + `?type=${url[1]}&page=${page}&lang=${props?.language?.toLowerCase()}`;
         }
      }
    } else {
      if(url[1] === "vendor") {
          console.log("hello",url[3]);
          getUrl = MY_RIDES + `?type=${url[1]}&page=${page}&read_status_update=${"yes"}&status=${url[3]}&lang=${props?.language?.toLowerCase()}`;
         }else{
          getUrl = MY_RIDES + `?type=${url[1]}&page=${page}&lang=${props?.language?.toLowerCase()}`;
         }
    }
    let getMyrideresponse = await getRequestcall(getUrl, props?.access_token);
    if (getMyrideresponse?.status === 200) {
      let getDetail = await getMyrideresponse.json();
      if (getDetail?.data?.data.length === 0) {
        setNodata(true);
      } else {
        if (props?.dashboard === true) {
          const recentlySold = getDetail?.data?.data?.filter(
            (item, index) => index < 4
          );
          setRidedetail({
            data: recentlySold,
          });
        } else {
          props?.receivedRidecount(0);
          setRidedetail(getDetail?.data);
        }
        setNodata(false);
      }
    } else if (getMyrideresponse?.status === 400) {
      let getError = await getMyrideresponse?.json();
      if (getError?.error?.is_deleted) {
        props?.clearStoredetail([]);
        props.logindata.type = "user";
        props.fetchLogindata(props.logindata);
        navigate("/vendor/");
      } else {
        setNodata(true);
        toast.error(getError?.errors);
      }
    }
  };

  const bookStatus = async (e, id, type) => {
    e.preventDefault();
    let title = ""
    if(type === "Cancelled"){
      title = t('pages.Are you sure you want to cancel this ride?')
    }
    if(type === "Completed"){
      title = t('pages.Are you sure you want to complete this ride?')
    }
    if(type === "Confirmed"){
      title = t('pages.Are you sure you want to confirm this ride?')
    }
    const payload = {
      itemDelete:()=>callCallBackModal(id, type),
      title:title,
      show:true
    }
    // console.log("payload", payload)
    dispatch(setStoreModalPopupShow(payload));
  }
  const callCallBackModalRedux =() =>{
    if(modal_common?.itemDelete){
      modal_common?.itemDelete()
    }
    callSetState();
  }
  const callCallBackModal = async (id, type) => {
    let getUrl = BOOKING_STATUS + `?booking_id=${id}&status=${type}&lang=${props?.language?.toLowerCase()}`;
    let getChangebookingresponse = await postRequestcall(
      getUrl,
      props.access_token,
      ""
    );
    if (getChangebookingresponse?.status === 200) {
      const result = await  getChangebookingresponse?.json();
      toast(result?.msg);
      await callUpdateBookingNotification(id, type);
      // console.log("page", result);
      myRidelisting(page);
    }
  };
  const callUpdateBookingNotification = async (id, type) =>{
    const payload = {
      booking_id:id,
      status:type,
      lang:props?.language?.toLowerCase()
    }
     await postRequestcall(API_SEND_BOOKING_STATUS_NOTIFICATION, props?.access_token, payload);
    // console.log("response", response)
  }
  const callRidelist = (pages) => {
    myRidelisting(pages);
    setPage(pages);
  };

  const renderType = (item) => {
    switch (item) {
      case "One way":
        return props?.language === "Tr" ? "Tek yön" : "One way";
      case "Round trip":
        return props?.language === "Tr" ? "Gidiş - Dönüş" : "Round trip";
      case "Airport":
        return props?.language === "Tr" ? "Havalimanı" : "Airport"
      default:
        break;
    }
  }

  return (
    <section className="my-ride">
      {
        ridedetail.data?.map((item, index) => (
          <div className="ridelist-mobile">
            <div className="location">
              <img
                alt="Car Images"
                onError={(e) => {
                  e.target.src = default_car;
                }}
                src={
                  typeof item?.driver_details?.vehicle_image[0] ===
                    "undefined"
                    ? default_car
                    : item?.driver_details?.vehicle_image[0]
                }
              ></img>
              <div className="location-detail">
                <ul className="list-ic vertical">
                  <li>
                    <span className="dot-red"></span>
                    <div>
                      <label className="pickup-location ms-2">
                        {t("pages.myrides.pickup_location")}
                      </label>
                      <h6 className="ms-2 location-address">
                        {item?.pick_up_address}
                      </h6>
                    </div>
                  </li>
                  <li>
                    <span className="dot-green"></span>
                    <div>
                      <label className="ms-2">
                        {t("pages.myrides.destination_location")}
                      </label>
                      <h6 className="ms-2 location-address">
                        {item?.drop_address}
                      </h6>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <Row>
              <div className="d-flex flex-column col-6">
                <div>
                  <label>{t("pages.myrides.car_name")}</label>
                  <h6 className="car-name">
                    {item?.vehicle_type?.car_model?.charAt(0)?.toUpperCase() +
                      item?.vehicle_type?.car_model?.slice(1)}
                  </h6>
                </div>
                <div>
                  <label>{t("pages.myrides.kilometer")}</label>
                  <h6>{item.kilometer} kms</h6>
                </div>
                <div>
                  <label>{t("pages.myrides.transfer_type")}</label>
                  <h6>
                    {renderType(item.booking_type?.charAt(0)?.toUpperCase() +
                      item.booking_type?.slice(1))}
                  </h6>
                </div>
              </div>
              <div className="d-flex flex-column col-6">
                <div className="pickupdate-box">
                  <label>{t("pages.myrides.pickup_date")}</label>
                  <h6>
                     {moment(item?.date +" "+ item.time).format("DD-MM-YYYY hh:mm A")}
                    {/* <Day date={item?.date}/> <ShortMonth date={item?.date} /> <Year date={item?.date}/> <ValidateTime time={moment(item?.date +" "+ item.time).format("MMMM hh:mm a")} /> */}
                  </h6>
                </div>
                <div className="price-box">
                  <label>{t("pages.myrides.price")}</label>
                  <h6>
                    {item?.price} {process.env.REACT_APP_CURRENCY_SYMBOL}
                  </h6>
                </div>
                <div className="status-box">
                  <label>{t("pages.dashboard.status")}</label>
                  {item?.status === "Cancelled" ? (
                    <h6 className="cab-status" style={{ color: "#FF0000" }}>
                      {t("pages.cancel")}
                    </h6>
                  ) : item?.status === "Completed" ? (
                    <h6 className="cab-status" style={{ color: "#006400" }}>
                      {t("pages.myrides.completed")}
                    </h6>
                  ) : item?.status === "Confirmed" ? (
                    <h6 className="cab-status" style={{ color: "#0000FF" }}>
                      {t("pages.myrides.confirmed")}
                    </h6>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </Row>
            <h5 className="detail-lable">
              {url[1] === "vendor"
                ? t("pages.myrides.customer_datail")
                : t("pages.myrides.driver_detail")}
            </h5>
            <Row>
              <div className="d-flex flex-column col-6">
                <div>
                  <label>{url[1] === "vendor" ? t("pages.myrides.customer_name") : t("pages.driver_detail.driver_name")}</label>
                  <h6>{url[1] === "vendor"
                    ? item?.first_name + " " + item?.last_name
                    : item?.driver_details?.driver_name}</h6>
                </div>
                <div className="d-flex flex-column">
                  <label>{t("pages.myrides.email_address")}</label>
                  <a
                    href={`mailto: ${url[1] === "vendor"
                      ? item.email
                      : item?.driver_details?.email
                      }`}
                  >
                    {url[1] === "vendor"
                      ? item.email
                      : item?.driver_details?.email}
                  </a>
                </div>
              </div>
              <div className="d-flex flex-column col-6">
                <div className="d-flex flex-column">
                  <label>{t("pages.myrides.mobile_num")}</label>
                  <a
                    href={`tel:+90 ${url[1] === "vendor"
                      ? item?.country_code + " " + item?.mobile_number
                      : item?.driver_details?.country_code +
                      " " +
                      item?.driver_details?.contact
                      }`}
                  >
                    {url[1] === "vendor"
                      ? item?.country_code + " " + item?.mobile_number
                      : item?.driver_details?.country_code +
                        " " +
                        typeof item?.driver_details?.contact ===
                        "undefined"
                        ? ""
                        : item?.driver_details?.contact}
                  </a>
                </div>
              </div>
            </Row>
            {url[1] === "vendor" ? (
              <div className="col-sm-12 col-md-2 col-lg-4 col-xl-4 d-flex mb-1 mt-2">
                {item?.status === "Confirmed" ||
                  item?.status === "Completed" ||
                  item?.status === "Cancelled" ? (
                  <></>
                ) : (
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "#2F8AF4",
                    }}
                    className="btn-submit hover-btn me-2 ride-cancel"
                    onClick={(e) => bookStatus(e, item?.id, "Confirmed")}
                  >
                    {t("pages.myrides.confirmed")}
                  </button>
                )}
                {item?.status === "Completed" ||
                  item?.status === "Cancelled" ? (
                  <></>
                ) : (
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "#38C432",
                    }}
                    className="btn-submit hover-btn me-2 ride-cancel"
                    id="status"
                    onClick={(e) => bookStatus(e, item?.id, "Completed")}
                  >
                    {t("pages.myrides.completed")}
                  </button>
                )}
                {
                  item?.status !== "Cancelled" && item?.status !== "Completed" && (
                    <button
                      type="submit"
                      className="btn-submit hover-btn me-2 ride-cancel"
                      id="status"
                      onClick={(e) => bookStatus(e, item?.id, "Cancelled")}
                    >
                      {t("pages.cancel")}
                    </button>
                  )
                }
              </div>
            ) : item?.status === "Cancelled" ||
              item?.status === "Completed" ? (
              <></>
            ) : (
              <div className="col-sm-12 col-md-3 col-lg-4 col-xl-4 text-end pb-3">
                <button
                  type="submit"
                  className="btn-submit hover-btn me-2 ride-cancel"
                  id="status"
                  onClick={(e) => bookStatus(e, item?.id, "Cancelled")}
                >
                  {t("pages.cancel")}
                </button>
              </div>
            )}
          </div>
        ))
      }
      {nodata === true ? (
        <NodatafoundPage
          className={"col-xl-12 main-content offerlist-centent"}
          image={no_orders}
          button={t("pages.backtodashboard")}
          title={t("pages.No rides found")}
          description={""}
          navigation={"/vendor/dashboard"}
        />
      ) : (
        ridedetail.data?.map((item, index) => (
          <div className="card mb-4" key={index?.toString()}>
            <Row className="detail">
              <div className="col-sm-12 col-md-12 col-lg-2 col-xl-2 ps-0 position-relative picture">
                <img
                  className="vehicle-img"
                  alt="Vehicle Images"
                  onError={(e) => {
                    e.target.src = default_car;
                  }}
                  src={
                    typeof item?.driver_details?.vehicle_image[0] ===
                      "undefined"
                      ? default_car
                      : item?.driver_details?.vehicle_image[0]
                  }
                ></img>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-3 col-xl-3 ps-0">
                <ul className="list-ic vertical">
                  <li>
                    <span></span>
                    <div>
                      <label className="ms-2">
                        {t("pages.myrides.pickup_location")}
                      </label>
                      <h6 className="ms-2 location-address">
                        {item?.pick_up_address}
                      </h6>
                    </div>
                  </li>
                  <li>
                    <span className="dot-green"></span>
                    <div>
                      <label className="ms-2">
                        {t("pages.myrides.destination_location")}
                      </label>
                      <h6 className="ms-2 location-address">
                        {item?.drop_address}
                      </h6>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 ps-0">
                <Row>
                  <div className="col-5">
                    <div className="car-detail">
                      <label>{t("pages.myrides.car_name")}</label>
                      <h6 className="car-name">
                        {item?.vehicle_type?.car_model?.charAt(0)?.toUpperCase() +
                          item?.vehicle_type?.car_model?.slice(1)}
                      </h6>
                    </div>
                    <div>
                      <label>{t("pages.myrides.kilometer")}</label>
                      <h6>{item.kilometer} kms</h6>
                    </div>
                  </div>
                  <div className="col-5">
                    <div className="car-detail">
                      <label>{t("pages.myrides.pickup_date")}</label>
                      <h6>
                        {moment(item?.date +" "+ item.time).format("DD-MM-YYYY hh:mm A")}
                        {/* <Day date={item?.date}/> <ShortMonth date={item?.date} /> <Year date={item?.date}/> <ValidateTime time={moment(item?.date +" "+ item.time).format(" hh:mm a")} /> */}
                      </h6>
                    </div>
                    <div>
                      <label>{t("pages.myrides.price")}</label>
                      <h6>
                        {item?.price} {process.env.REACT_APP_CURRENCY_SYMBOL}
                      </h6>
                    </div>
                  </div>
                </Row>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-1 col-xl-1 ps-0">
                <div className="car-detail">
                  <label>{t("pages.myrides.transfer_type")}</label>
                  <h6>
                    {renderType(item.booking_type?.charAt(0)?.toUpperCase() +
                      item.booking_type?.slice(1))}
                  </h6>
                </div>
                <div>
                  {item.booking_type === "round trip" && (
                    <>
                      <label>{t("pages.myrides.return_date")}</label>
                      <h6>
                        {
                          (item?.return_date !== null || item?.return_time !== null) && (
                           <React.Fragment>
                            {moment(item?.return_date +" "+ item.return_time).format("DD-MM-YYYY hh:mm A")}
                              {/* <Day date={item?.return_date}/> <ShortMonth date={item?.return_date} /> <Year date={item?.return_date}/> <ValidateTime time={moment(item?.return_date +" "+ item.return_time).format(" hh:mm a")} /> */}
                           </React.Fragment>
                          )
                        }
                      </h6>
                    </>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-2 col-xl-2 ps-0 status-div">
                <div className="car-detail">
                  <label>{t("pages.dashboard.status")}</label>
                  {item?.status === "Cancelled" ? (
                    <h6 className="cab-status" style={{ color: "#FF0000" }}>
                      {t("pages.cancel")}
                    </h6>
                  ) : item?.status === "Completed" ? (
                    <h6 className="cab-status" style={{ color: "#006400" }}>
                      {t("pages.myrides.completed")}
                    </h6>
                  ) : item?.status === "Confirmed" ? (
                    <h6 className="cab-status" style={{ color: "#0000FF" }}>
                      {t("pages.myrides.confirmed")}
                    </h6>
                  ) : (
                    <h6 className="cab-status" style={{ color: "#000000" }}>
                      {t("pages.myrides.booked")}
                    </h6>
                  )}
                </div>
              </div>
            </Row>
            <Row className="detail-row pb-1">
              <h5 className="detail-lable">
                {url[1] === "vendor"
                  ? t("pages.myrides.customer_datail")
                  : t("pages.myrides.driver_detail")}
              </h5>
              <div className="col-sm-12 col-md-3 col-lg-2 col-xl-2 ps-0">
                <label className="ms-2">
                  {url[1] === "vendor" ? t("pages.myrides.customer_name") : t("pages.driver_detail.driver_name")}
                </label>
                <h6 className="ms-2">
                  {url[1] === "vendor"
                    ? item?.first_name + " " + item?.last_name
                    : item?.driver_details?.driver_name}
                </h6>
              </div>
              <div className={url[1] === "user" ? "col-sm-12 col-md-3 col-lg-3 col-xl-3 ps-0 d-flex flex-column" : "col-sm-12 col-md-3 col-lg-3 col-xl-3 ps-0 d-flex flex-column"} >
                <label>{t("pages.myrides.email_address")}</label>
                <a
                  href={`mailto: ${url[1] === "vendor"
                    ? item.email
                    : item?.driver_details?.email
                    }`}
                >
                  {url[1] === "vendor"
                    ? item.email
                    : item?.driver_details?.email}
                </a>
              </div>
              <div className="col-sm-12 col-md-2 col-lg-3 col-xl-3 ps-0 d-flex flex-column">
                <label>{t("pages.myrides.mobile_num")}</label>
                <a
                  href={`tel:+90 ${url[1] === "vendor"
                    ? item?.country_code + " " + item?.mobile_number
                    : item?.driver_details?.country_code +
                    " " +
                    item?.driver_details?.contact
                    }`}
                >
                  {url[1] === "vendor"
                    ? item?.country_code + " " + item?.mobile_number
                    : item?.driver_details?.country_code +
                      " " + item?.driver_details?.contact}
                </a>
              </div>
              {url[1] === "vendor" ? (
                <div className="col-sm-12 col-md-2 col-lg-4 col-xl-4 text-end mb-1">
                  {item?.status === "Confirmed" ||
                    item?.status === "Completed" ||
                    item?.status === "Cancelled" ? (
                    <></>
                  ) : (
                    <button
                      type="submit"
                      style={{
                        backgroundColor: "#2F8AF4",
                      }}
                      className="btn-submit hover-btn me-2 btncab-status"
                      onClick={(e) => bookStatus(e, item?.id, "Confirmed")}
                    >
                      {t("pages.myrides.confirmed")}
                    </button>
                  )}
                  {item?.status === "Completed" ||
                    item?.status === "Cancelled" ? (
                    <></>
                  ) : (
                    <button
                      type="submit"
                      style={{
                        backgroundColor: "#38C432",
                      }}
                      className="btn-submit hover-btn me-2 btncab-status"
                      id="status"
                      onClick={(e) => bookStatus(e, item?.id, "Completed")}
                    >
                      {t("pages.myrides.completed")}
                    </button>
                  )}
                  {item?.status === "Cancelled" ||
                    item?.status === "Completed" ? (
                    <></>
                  ) : (
                    <button
                      type="submit"
                      className="btn-submit hover-btn me-2 btncab-status"
                      id="status"
                      onClick={(e) => bookStatus(e, item?.id, "Cancelled")}
                    >
                      {t("pages.cancel")}
                    </button>
                  )}
                </div>
              ) : (
                <div className="col-sm-12 col-md-2 col-lg-4 col-xl-4 text-end mb-1">
                  {item?.status === "Cancelled" ||
                    item?.status === "Completed" ? (
                    <></>
                  ) : (
                    <button
                      type="submit"
                      className="btn-submit hover-btn me-2 btncab-status"
                      id="status"
                      onClick={(e) => bookStatus(e, item?.id, "Cancelled")}
                    >
                      {t("pages.cancel")}
                    </button>
                  )}
                </div>
              )}
            </Row>
          </div>
        ))
      )}
      {!nodata && !props?.dashboard && ridedetail?.total > 10 && (
        <div className="text-end">
          <PaginationPage
            changeCurrentpage={callRidelist}
            nopagination={nodata}
            links={ridedetail?.links}
          />
        </div>
      )}
      <DeletepopupPage
        deleteModal={modal_common?.show}
        deleteInfo={{
          title:modal_common?.title,
          type:modal_common?.type,
          // title:modal_common?.title,
        }}
        setDeleteModal={callSetState}
        itemDelete={callCallBackModalRedux}
      />
    </section>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  logindata: state?.login?.logindata,
  language: state?.languageState?.language,
  
});

export default connect(mapStateToProps, { clearStoredetail, fetchLogindata,receivedRidecount })(MyridePage);
